import React, {Component, PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, Tooltip, DatePicker, Select, Drawer, notification} from 'antd'
import _ from 'lodash'
import Request, {API_URL} from '../../request'
import {connect} from 'react-redux'
// import StaffLeaveAction from '../../components/_utils/staffLeaveAction.js'
import moment from 'moment'
// import AddStaffLeave from '../../components/_utils/addStaffLeave';
import { RightsWrapper } from '../../components/_utils/utils'



const {MonthPicker} = DatePicker
const Option = Select.Option;


@Form.create()
class GenerateLetterOfIntent extends Component {
    state={
        visible:true,
    }


    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = (e) =>{
        e.preventDefault()
        const {form} = this.props
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData)
            let response = await Request.AddLetterOfIntent(values)
            if(response.success) {
                notification.success({
                    message:response.message
                })
                
            }else  {
                notification.error({
                    message:response.message
                })
            }
            this.onClose()
        })
    }

    render() {

        const inputTypes = {
            fields:[
                {
                    title:'Name',
                    key:'userName',
                    required:true,
                    type:'text'
                },
                {
                    title:'Email Id',
                    key:'userEmail',
                    required:true,
                    type:'text'
                },
                {
                    title:'Designation',
                    key:'designationOffered',
                    required:true,
                    type:'text'
                },
                {
                    title:'Location',
                    key:'jobLocation',
                    required:true,
                    type:'text'
                },
                {
                    title:'Shift Timing',
                    key:'shiftTiming',
                    required:true,
                    type:'text'
                },
                {
                    title:'Week Days',
                    key:'weekDays',
                    required:true,
                    type:'text'
                },
                {
                    title:'Salary Per Month',
                    key:'offeredSalary',
                    required:true,
                    type:'text'
                },
                {
                    title:'Joining Date',
                    type:'date',
                    required:true,
                    key:'offeredJoiningDate'
                },
                {
                    title:'Joining Time',
                    type:'time',
                    required:true,
                    key:'offeredJoiningTime'
                },
                {
                    title:'Email Subject',
                    key:'emailSubject',
                    required:true,
                },
                {
                    title:'Reply To',
                    key:'replyTo',
                    type:'email',
                    required:true,
                }
            ]
        }
        const {
            form: {getFieldDecorator}
        } = this.props
        const {visible} = this.state
        return (
            <Drawer 
            title={
                <div>
                    <React.Fragment>
                        Generate Letter of Intent
                    </React.Fragment>
                </div>
            }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={600}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                        <div>
                        <GetAllFormFields
                                apiurl={API_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}


@Form.create()
class LetterOfIntent extends PureComponent {

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.state = {
            defaultPageSize: 50,
            total:0,
            showRegularisationForm:false,
            record:{},
            month:moment(),
            allUsers:[],
            userId:'',
            showLetterOfIntentForm:false
        }
    }

    reload = () => {    
        this.table.current.reload();
    };  

    handleMonthChange = (month,dateString) =>{
        this.setState({month:moment(month)}, ()=>{
            this.reload()
        })
    }

    apiRequest = (params) => {
        return new Promise(async(resolve)=>{
            let response = await Request.getAllLetterOfIntent(params);
            this.setState({total:response.total})
            resolve(response)
        })
    }

    handleLetterOfIntent = () =>{
        this.setState({showLetterOfIntentForm:true})
    }

    handleRegularisationRequests = (record) =>{
        this.setState({showRegularisationForm:true, record:record})
    }

    getCurrentUser = () => {
        let response = JSON.parse(localStorage.getItem('user'))
        return response
    }

    async componentDidMount(){
        let params = {
            sortField:'_id',
            sortOrder:'ascend',
            results: 200,
            active:true,
            userType:{$ne : "Student"}
        };
        let activeUser = this.getCurrentUser();
        params.userBranch = activeUser.userBranch
        let response = await Request.loadUser({...params, regExFilters: ['name', 'email']})
        let userArray = [];
        response.data.map((user, index)=>{
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({allUsers:userArray})
    }

    handleFormClose = () => {
        this.setState({showLetterOfIntentForm:false})
        this.table.current.reload()
    }

    render(){
        const {defaultPageSize, total, showLetterOfIntentForm} = this.state
        const columns = [
            {
                title:'Name',
                key:'userName',
                fixed:true,
                width:180
            },
            {
                title:'Email',
                key:'userEmail'
            },
            {
                title:'Joining Date',
                key:'offeredJoiningDate',
                render:(text,record)=>(
                    <div>{moment(record.offeredJoiningDate).format('DD-MM-YYYY')}</div>
                )
            },
            {
                title:'Joining Time',
                key:'offeredJoiningTime',
                render:(text,record)=>(
                    <div>{moment(record.offeredJoiningTime, 'HH:mm').format('HH:mm')}</div>
                )
            },
            {
                title:'Designation',
                key:'designationOffered'
            }
        ]
        return (
            <PageHeaderWrapper title={`Letter Of Intent:- ${total}`}>
                {
                    showLetterOfIntentForm?
                    <GenerateLetterOfIntent onClose={this.handleFormClose} />
                    :null
                }
                <Card bordered={true}>
                <Row>
                    <Col span={4}>
                        <Button onClick={this.handleLetterOfIntent}>Generate Letter of Intent</Button>
                    </Col>
                    
                </Row>
            </Card>
                <Card bordered={true}>
                <TableComp
                    ref={this.table}
                    columns={columns}
                    apiRequest={this.apiRequest}
                    extraProps={{scroll: {x: 1000}}}
                    pagination={{
                    showSizeChanger: false,
                    defaultPageSize: defaultPageSize,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
                </Card>
            </PageHeaderWrapper>
        )
    }
}
const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LetterOfIntent)